/* ═══════════════════════════════════════════════════════════════════════════
   your moments — Warenkorb-Anbindung für das ZBV-Theme (Focal)
   Ersetzt Dawns product-form.js in ym-pdp-hero und ym-product-feature.
   Legt per AJAX in den Warenkorb und übergibt dann an Focals eigenen
   Warenkorb-Drawer (Events cart:updated / cart:refresh / variant:added).
   Findet es keinen Focal-Drawer, leitet es auf /cart weiter.
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  if (customElements.get('ym-product-form')) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var tv = window.themeVariables || {};
  var cartUrl = (tv.routes && tv.routes.cartUrl) || root + 'cart';
  var addUrl = (tv.routes && tv.routes.cartAddUrl) || root + 'cart/add';

  class YmProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.submitButton = this.form.querySelector('[type="submit"]');
      this.spinner = this.submitButton && this.submitButton.querySelector('.loading__spinner');
      this.errorWrap = this.querySelector('.product-form__error-message-wrapper');
      this.errorText = this.querySelector('.product-form__error-message');
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    setLoading(on) {
      if (!this.submitButton) return;
      this.submitButton.classList.toggle('loading', on);
      this.submitButton.toggleAttribute('aria-busy', on);
      if (on) this.submitButton.setAttribute('aria-disabled', 'true');
      else this.submitButton.removeAttribute('aria-disabled');
      if (this.spinner) this.spinner.hidden = !on;
    }

    showError(msg) {
      if (!this.errorWrap) return;
      this.errorWrap.hidden = !msg;
      if (this.errorText) this.errorText.textContent = msg || '';
    }

    async onSubmit(event) {
      event.preventDefault();
      if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.showError('');
      this.setLoading(true);

      var body = new FormData(this.form);
      // Leeres selling_plan weist die Cart-API zurück (Muster aus pdp-v2.js).
      if (!body.get('selling_plan')) body.delete('selling_plan');
      // Focal rendert den Drawer aus genau dieser Section neu.
      body.append('sections', 'mini-cart');

      try {
        var res = await fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: body
        });
        var json = await res.json();
        if (!res.ok || json.status) {
          this.showError(json.description || json.message || 'Das hat leider nicht geklappt.');
          return;
        }

        var hasFocalDrawer = !!document.querySelector('#mini-cart, cart-drawer, [is="cart-drawer"]');
        this.dispatchEvent(new CustomEvent('variant:added', {
          bubbles: true,
          detail: { variant: json }
        }));

        var cart = await (await fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })).json();
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        var openDrawer = !tv.settings || tv.settings.cartType === 'drawer';
        cart.sections = json.sections;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart: cart, openMiniCart: openDrawer }
        }));

        if (!hasFocalDrawer || (tv.settings && tv.settings.cartType === 'page')) {
          window.location.href = cartUrl;
        }
      } catch (e) {
        this.showError('Verbindungsproblem – bitte noch einmal versuchen.');
      } finally {
        this.setLoading(false);
      }
    }
  }

  customElements.define('ym-product-form', YmProductForm);
})();
